import { Component, Input } from '@angular/core';
import { IReport } from '@shared/interfaces';

@Component({
    selector: 'app-report-view-placeholder',
    templateUrl: './report-view-placeholder.component.html',
    styleUrls: ['./report-view-placeholder.component.scss'],
    standalone: false
})
export class ReportViewPlaceholderComponent {
    @Input() placeholderArray: IReport[];

    @Input() set countWithDelay(val: { count: number; delay?: number }) {
        setTimeout(
            () => {
                this.placeholderArray = Array<IReport>(val.count).fill({});
            },
            val.delay ? val.delay : 0
        );
    }
}
